








import {Component, Prop, Vue} from "vue-property-decorator";

@Component
export default class HeaderBar extends Vue {
    home() {
        console.log(12312);
    }
}
